__webpack_require__.p = "//samurai-hub-video-front-app.staging.it-incubator.ru/";